import { logUsage } from 'owa-analytics';
import getCurrentZoomScale from 'owa-custom-zoom-store/lib/utils/getCurrentZoomScale';

export default function logEmbiggenZoomSettingDatapoint() {
    logUsage('EmbiggenZoomSetting', { zoomScale: getCurrentZoomScale() });
}
